import { Fragment, lazy } from 'react'

import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { SiteFooterV2 } from '@/components/layout/site-footer'
import { SiteHeader } from '@/components/layout/site-header'
import { Toaster } from '@/components/ui/sonner'

import { useAuth } from '@/services/auth/auth.store'

import { IS_DEV } from '@/lib/constant'

interface RouteContext {
  qc: QueryClient
}

const DevToolsLazy = IS_DEV
  ? lazy(() => import('../components/misc/dev-tools'))
  : Fragment

export const Route = createRootRouteWithContext<RouteContext>()({
  beforeLoad: async ({ context }) => {
    await useAuth.getState().hydrate()
  },
  component: () => (
    <div className="font-dm-sans relative flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <SiteFooterV2 />
      <Toaster position="top-center" />
      {/* <DevToolsLazy /> */}
    </div>
  ),
})
